import { _ as _define_property } from "@swc/helpers/_/_define_property";
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { ConstructionIcon } from "@faire/retailer/features/Showroom/ShowroomVettingCriteria/ConstructionIcon";
import { FabricsIcon } from "@faire/retailer/features/Showroom/ShowroomVettingCriteria/FabricsIcon";
import { PreciseFitIcon } from "@faire/retailer/features/Showroom/ShowroomVettingCriteria/PreciseFitIcon";
export var VETTING_CRITERIA;
(function(VETTING_CRITERIA) {
    VETTING_CRITERIA["QUALITY_FABRICS"] = "QUALITY_FABRICS";
    VETTING_CRITERIA["THOUGHTFUL_CONSTRUCTION"] = "THOUGHTFUL_CONSTRUCTION";
    VETTING_CRITERIA["PRECISE_FIT"] = "PRECISE_FIT";
})(VETTING_CRITERIA || (VETTING_CRITERIA = {}));
export var showroomVettingCriteriaInfo = function(color, shouldShowVettingValueDescription, titleTypographyVariants, strictLocalize) {
    var _obj;
    return _obj = {}, _define_property(_obj, VETTING_CRITERIA.QUALITY_FABRICS, {
        icon: /*#__PURE__*/ _jsx(FabricsIcon, {
            color: color
        }),
        vettingValue: strictLocalize({
            id: "Fl/JIi",
            defaultMessage: [
                {
                    type: 0,
                    value: "Quality fabrics"
                }
            ]
        }),
        vettingValueDescription: shouldShowVettingValueDescription ? strictLocalize({
            id: "AJPjQx",
            defaultMessage: [
                {
                    type: 0,
                    value: "We review fabric composition, weight, and texture, and look for the inclusion of natural fibers like cotton, silk, cashmere, and leather as good indicators of quality."
                }
            ]
        }) : undefined,
        color: color,
        titleTypographyVariants: titleTypographyVariants
    }), _define_property(_obj, VETTING_CRITERIA.PRECISE_FIT, {
        icon: /*#__PURE__*/ _jsx(PreciseFitIcon, {
            color: color
        }),
        vettingValue: strictLocalize({
            id: "FEAZxI",
            defaultMessage: [
                {
                    type: 0,
                    value: "Precise fit"
                }
            ]
        }),
        vettingValueDescription: shouldShowVettingValueDescription ? strictLocalize({
            id: "wJXUkZ",
            defaultMessage: [
                {
                    type: 0,
                    value: "Quality garments are tailored to fit the body and give it shape. We look at darts, seams, and topstitching, as well as how an item drapes to provide movement."
                }
            ]
        }) : undefined,
        color: color,
        titleTypographyVariants: titleTypographyVariants
    }), _define_property(_obj, VETTING_CRITERIA.THOUGHTFUL_CONSTRUCTION, {
        icon: /*#__PURE__*/ _jsx(ConstructionIcon, {
            color: color
        }),
        vettingValue: strictLocalize({
            id: "2VbgxL",
            defaultMessage: [
                {
                    type: 0,
                    value: "Thoughtful construction"
                }
            ]
        }),
        vettingValueDescription: shouldShowVettingValueDescription ? strictLocalize({
            id: "HoopyD",
            defaultMessage: [
                {
                    type: 0,
                    value: "To ensure each item is designed and produced with care, we check everything from zippers and linings to transparent manufacturing methods."
                }
            ]
        }) : undefined,
        color: color,
        titleTypographyVariants: titleTypographyVariants
    }), _obj;
};
